/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Guides_Analysis_ExampleInputs */

const en_gc_guides_analysis_example = /** @type {(inputs: Gc_Guides_Analysis_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A source table with two regions and two products, followed by expected totals.`)
};

const zh_gc_guides_analysis_example = /** @type {(inputs: Gc_Guides_Analysis_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`包含两个地区和两种产品的来源表，以及预期汇总结果。`)
};

/**
* | output |
* | --- |
* | "A source table with two regions and two products, followed by expected totals." |
*
* @param {Gc_Guides_Analysis_ExampleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_guides_analysis_example = /** @type {((inputs?: Gc_Guides_Analysis_ExampleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Guides_Analysis_ExampleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_guides_analysis_example(inputs)
	return zh_gc_guides_analysis_example(inputs)
});
export { gc_guides_analysis_example as "gc.guides.analysis.example" }